import { useEffect, useState } from 'react'

export const usePermission = (name: PermissionName) => {
  const [permission, setPermission] = useState<PermissionState | null>(null)

  useEffect(() => {
    if (!(navigator.permissions && navigator.permissions.query)) {
      setPermission('prompt')
      return
    }

    void navigator.permissions.query({ name }).then(permissionStatus => {
      permissionStatus.addEventListener('change', () => {
        setPermission(permissionStatus.state)
      })
      setPermission(permissionStatus.state)
    })
  }, [name])

  return { permission, disabled: permission !== 'granted' }
}
